<script>
/* eslint-disable camelcase */
import helpers from "@/packages/cassandra-base/utilities/helpers/helper.js";

export default {
  name: "RecallsList",
  props: ["type", "employeeNo"],
  data() {
    return {
      headers: [
        { text: "RecallNo", align: "start", value: "recallNo" },
        { text: "Leave", value: "leavetype" },
        { text: "Employee", value: "employeeName" },
        { text: "Return Date", value: "returnDate" },
        { text: "Recall Days", align: "center", value: "recallDays" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" },
      ],
      columns: [],
      loading: false,
    };
  },

  mounted() {
    this.fetchRecords();
  },

  methods: {
    getDateFormat: function (date) {
      return helpers.getDateFormat(date);
    },
    getColor: function (status) {
      return helpers.getColor(status);
    },

    fetchRecords: function () {
      const payload = {
        employeeNo: this.type === "my-recalls" ? this.employeeNo : null,
        requestedByEmployeeNo:
          this.type === "supervisor-recalls" ? this.employeeNo : null,
      };

      this.loading = true;

      this.$store
        .dispatch("leaveRecall/getRecalls", payload)
        .then((response) => {
          this.columns = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    viewRecord: function (item) {
      this.$router.push({
        name: "ViewLeaveRecall",
        params: {
          no: item.recallNo,
        },
      });
    },
  },
};
</script>

<template>
  <v-data-table
    :headers="headers"
    :items="columns"
    :items-per-page="10"
    class="elevation-1"
  >
    <template v-slot:item.status="{ item }">
      <v-chip label :color="getColor(item.status).color" small>
        {{ item.status }}
      </v-chip>
    </template>

    <template v-slot:item.recallDate="{ item }">
      {{ getDateFormat(item.recallDate) }}
    </template>

    <template v-slot:item.returnDate="{ item }">
      {{ getDateFormat(item.returnDate) }}
    </template>

    <template v-slot:item.employeeName="{ item }">
      {{ item.employeeName }} ({{ item.employeeNo }})
    </template>

    <template v-slot:item.leavetype="{ item }">
      {{ item.leavetype.description || "N/A" }} ({{ item.applicationCode }})
    </template>

    <template v-slot:item.action="{ item }">
      <div class="d-flex justify-start">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              class="primary lighten-4 mx-1"
              v-bind="attrs"
              v-on="on"
              label
              @click="viewRecord(item)"
            >
              <v-icon color="primary darken-4">pageview</v-icon>
            </v-chip>
          </template>
          <span>View recall</span>
        </v-tooltip>
      </div>
    </template>
  </v-data-table>
</template>

<style scoped></style>
